const { construct } = require('../../tools')

function getByIds (state, ids, { date = new Date().toISOString() } = {}) {
  return getRaw(state, ids)
    .then(docs => docs.map(doc => construct(doc, { now: date })))
}

function getRaw (state, ids) {
  return state.productsDB.allDocs({
    keys: ids,
    include_docs: true
  })
    .then(results => results.rows
      .map(r => r.doc)
      .filter(r => r)
    )
}

function get (state, id) {
  return state.productsDB.get(id)
}

function getByAlias (state, aliasValue, aliasName) {
  const viewName = `by-${aliasName}-alias`
  const query = { include_docs: true }
  if (Array.isArray(aliasValue)) {
    query.keys = aliasValue
  } else {
    query.key = aliasValue
  }

  return state.productsDB
    .query(viewName, query)
    .catch((err) => {
      if (err.status === 404) {
        throw new Error(`No design doc found for view "${viewName}"`)
      }
      throw err
    })
}

async function listAll (state) {
  const allDocs = []
  const limit = 2500
  let startkey = 'product:'
  while (true) {
    const result = await state.productsDB.allDocs({
      startkey,
      endkey: 'product:\ufff0:',
      limit: limit + 1,
      include_docs: true
    })
    const docs = result.rows.slice(0, limit).map(r => r.doc)
    allDocs.push(...docs)
    if (docs.length < limit) {
      break
    }
    startkey = result.rows[result.rows.length - 1].id
  }
  return allDocs
}

function getProgramConfiguration (state, programId) {
  return state.productsDB.allDocs({
    startkey: `configuration:${programId}:service:`,
    endkey: `configuration:${programId}:service:\ufff0`,
    include_docs: true
  })
    .then((result) => result.rows.map(r => r.doc))
}

function getServiceConfiguration (state, serviceId) {
  return state.productsDB.allDocs({
    key: `configuration:${serviceId}`,
    include_docs: true
  })
    .then((result) => result.rows.map(r => r.doc))
}

module.exports = {
  getRaw,
  getByIds,
  get,
  getByAlias,
  listAll,
  getProgramConfiguration,
  getServiceConfiguration
}
